import { Heading, Input, Stack, Table, Tbody, Td, Tr, useToast } from '@chakra-ui/react';
import { Fragment } from 'react';

import { trpc } from '../config/trpc';

export const GeneralConfiguration = () => {
  const { data: configs, refetch, isLoading: isFetching } = trpc.getAllConfigs.useQuery();
  const { mutateAsync, isLoading: isUpdating } = trpc.updateConfiguration.useMutation();
  const toast = useToast();

  const update = async (scope: string, name: string, value: string) => {
    try {
      await mutateAsync({
        scope,
        name,
        value,
      });
      await refetch();
      toast({
        colorScheme: 'green',
        title: 'Success',
        description: 'Value updated',
      });
    } catch (e) {
      toast({
        colorScheme: 'red',
        title: 'Error',
        description: e?.message ?? 'An error occured',
      });
    }
  };

  return (
    <Stack spacing="2" maxH="100vh" h="full" overflowY="auto" p={4}>
      <Heading variant="h5">General Configuration</Heading>
      <Table variant="compact">
        <Tbody>
          {Object.entries(configs?.configs ?? {}).map(([category, subValues]) => (
            <Fragment key={category}>
              <Tr>
                <Td colSpan={3} fontWeight="bold" fontSize="2xl" p={3}>
                  {category}
                </Td>
              </Tr>
              {Object.entries(subValues).map(([name, value]) => (
                <Tr key={name}>
                  <Td>{name}</Td>
                  <Td>
                    <Input
                      disabled={isFetching || isUpdating}
                      name={`${category}.${name}`}
                      defaultValue={value}
                      onBlur={(e) => update(category, name, e.target.value)}
                    />
                  </Td>
                  <Td>{configs.descriptions[category][name]}</Td>
                </Tr>
              ))}
            </Fragment>
          ))}
        </Tbody>
      </Table>
    </Stack>
  );
};
